/*global google*/

import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, ListGroup } from 'react-bootstrap';

function AddressModal({
  showAddressModal,
  setShowAddressModal,
  onSaveAddress,
  addressVerified,
  addressErrors,
  setAddressInput,
  distanceText,
  addressInput,
  restaurantId,
  handleSelectSavedAddress
}) {
  const [savedAddresses, setSavedAddresses] = useState([]);
const [aptNumber, setAptNumber] = useState('');
const [deliveryInstructions, setDeliveryInstructions] = useState('');
  useEffect(() => {
    if (showAddressModal) {
      const key = `savedAddresses_${restaurantId}`;
      const saved = localStorage.getItem(key);
      if (saved) {
        setSavedAddresses(JSON.parse(saved));
      } else {
        setSavedAddresses([]);
      }
    }
  }, [showAddressModal, restaurantId]);

  const handleSaveClick = () => {
    if (addressVerified) {
      onSaveAddress(aptNumber, deliveryInstructions);
    }
  };



  return (
<>




    {/* Saved addresses */}
{savedAddresses.length > 0 && (
  <div className="mb-4">
    <h6 className="text-black fw-bold">
      Previous Addresses
    </h6>

    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
      <div className="overflow-y-auto" style={{ maxHeight: '220px' }}>
        {savedAddresses.map((addr, i) => (
          <div
            key={i}
            onClick={() => handleSelectSavedAddress(addr)}
            className={`px-4 py-3 cursor-pointer transition-colors duration-150 ${
              addr === addressInput ? 'bg-gray-50 border-l-4 border-black' : 'border-l-4 border-transparent'
            } ${i !== savedAddresses.length - 1 ? 'border-b border-gray-100' : ''}`}
            style={{
              color: '#333',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = addr === addressInput ? '#f5f5f5' : 'transparent'}
          >
            <div className="flex items-center">
         
              <span>{addr}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
<div className="mt-2 border border-secondary"></div>
  </div>
)}


  <Form>
  <Form.Group  className="mb-3 ">
    {/* Main Address Input */}
    <p className="text-sm text-muted mt-2">
  Start typing to search for your address or select from previous, and select from suggestions, If suggestions don’t appear, please refresh the page.
</p>
<div className="position-relative mb-3">
    <Form.Label className="fw-bold">Enter Address</Form.Label>
    
      <Form.Control
    id='autocomplete'
      type="text"
      placeholder="Enter delivery address..."
      value={addressInput}
      onChange={(e) => setAddressInput(e.target.value)}
      className="border-2 py-3 px-4 pe-5"
      style={{
        borderRadius: '8px',
        color: '#000',
        backgroundColor: '#fff',
        borderColor: '#e2e8f0',
        transition: 'all 0.2s ease',
        fontSize: '1rem',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        height: '52px', // match your input height
        lineHeight: '1.5', // ensure consistent line height
      }}
      onFocus={(e) => {
        e.target.style.borderColor = '#000';
        e.target.style.boxShadow = '0 0 0 2px rgba(0,0,0,0.1)';
      }}
      onBlur={(e) => {
        e.target.style.borderColor = '#e2e8f0';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }}
      autoComplete="off"
    />



  {/* Icon - perfectly centered */}
  <div
    className="position-absolute d-flex align-items-center"
    style={{
      right: '16px',
      top: '50%',
      transform: 'translateY(-20%)',
      height: '52px', // same as input
      pointerEvents: 'none',
      color: '#6c757d',
    }}
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  </div>
</div>


    {/* Apartment/Suite Number (Optional) */}
    <div className="mb-3">
      <Form.Control
        type="text"
        placeholder="Apartment, suite, etc. (optional)"
        value={aptNumber}
        onChange={(e) => setAptNumber(e.target.value)}
        className="border-2 py-3 px-4"
        style={{
          borderRadius: '8px',
          color: '#000',
          backgroundColor: '#fff',
          borderColor: '#e2e8f0',
          transition: 'all 0.2s ease',
          fontSize: '1rem',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          height: '52px'
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#000';
          e.target.style.boxShadow = '0 0 0 2px rgba(0,0,0,0.1)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = '#e2e8f0';
          e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
        }}
      />
    </div>

    {/* Delivery Instructions (Optional) */}
    <div className="mb-3">
      <Form.Control
        as="textarea"
        rows={3}
        placeholder="Delivery instructions (optional, eg. gate code 1234)"
        value={deliveryInstructions}
        onChange={(e) => setDeliveryInstructions(e.target.value)}
        className="border-2 py-3 px-4"
        style={{
          borderRadius: '8px',
          color: '#000',
          backgroundColor: '#fff',
          borderColor: '#e2e8f0',
          transition: 'all 0.2s ease',
          fontSize: '1rem',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
          resize: 'vertical',
          minHeight: '100px'
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#000';
          e.target.style.boxShadow = '0 0 0 2px rgba(0,0,0,0.1)';
        }}
        onBlur={(e) => {
          e.target.style.borderColor = '#e2e8f0';
          e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
        }}
      />
    </div>

    {/* Distance Information */}
    {distanceText && (
  <div className="mt-2 animate-fade-in" style={{ animation: 'fadeIn 0.3s ease' }}>
    <div className="flex items-start p-3 rounded-lg" style={{ 
      backgroundColor: 'rgba(112, 106, 106, 0.1)',
    }}>
      <div>
        <p className="mb-0" style={{ 
          fontSize: '0.875rem'
        }}>
          Your Address is {distanceText} from our store.
        </p>
      </div>
    </div>
  </div>
    )}

    {/* Error Message */}
{addressErrors && (
  <div className="mt-2 animate-fade-in" style={{ animation: 'fadeIn 0.3s ease' }}>
    <div className="flex items-start p-3 rounded-lg" style={{ 
      backgroundColor: 'rgba(239, 68, 68, 0.1)',
      borderLeft: '4px solid #ef4444'
    }}>
      <div>
        <p className="mb-0 mt-1" style={{ 
          color: '#b91c1c',
          fontSize: '0.875rem'
        }}>
          {addressErrors}
        </p>
      </div>
    </div>
  </div>
)}
  </Form.Group>
</Form>

    <div className="d-grid">
      <Button
        size="lg"
        className="fw-bold rounded-pill"
        disabled={!addressVerified}
        onClick={handleSaveClick}
      >
        Save
      </Button>
    </div>
</>


  );
}

export default AddressModal;
